import { memo, useState } from 'react';
import { IconButton, ListItemIcon, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { menuItemList } from '../../const/commonConst';
import theme from '../../../theme';

/**
 * ポップアップメニュー
 */
const PopUpMenu = () => {
	// ポップアップメニューの開閉状態を管理
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const moreVertOpen = Boolean(anchorEl);

	const handleMoreVertOpen = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMoreVertClose = () => {
		setAnchorEl(null);
	};

	return (
		<>
			<IconButton
				onClick={handleMoreVertOpen}
				sx={{
					color: theme.palette.common.white,
				}}
			>
				<MoreVertIcon />
			</IconButton>
			<Menu
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				anchorEl={anchorEl}
				open={moreVertOpen}
				onClose={handleMoreVertClose}
			>
				{menuItemList.map((menuItem) => (
					<MenuItem key={menuItem.value} value={menuItem.value} onClick={menuItem.onClick} sx={{ color: theme.palette.common.black }}>
						<ListItemIcon sx={{ color: theme.palette.common.black }}>
							<menuItem.icon />
						</ListItemIcon>
						{menuItem.name}
					</MenuItem>
				))}
			</Menu>
		</>
	);
};

export default memo(PopUpMenu);
